import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@material-ui/core";
import { ModalV2 } from "components/Modal/ModalV2";
import { useForm } from "hooks/useForm";
import { useSearch } from "hooks/useSearch";
import {
  assignUnitEquipment,
  getAvailableEquipment,
} from "redux/actions/adminUnits/adminUnitsActions";
import { getElectronicEquipmentTypes } from "redux/actions/electronicEquipment/electronicEquipmentActions";
import { ADMIN_UNIT_LOADINGS } from "redux/reducers/adminUnits/types";
import {
  EquipmentSelector,
  EMPTY_EQUIPMENT_VALUES,
  equipmentToValues,
} from "./EquipmentSelector";

const VALIDATIONS = {
  idEquipmentType: { required: true },
  equipment: { required: true },
};

/**
 * Asignación de equipo electrónico a unidad ESTACIONARIO (CRM-2959).
 * La selección de equipo vive en EquipmentSelector. Prefill por
 * data.idEquipment vía ?idCurrent. Submit → PUT /units/:id/equipment con { idEquipment }.
 */
export const AssignEquipmentForm = ({ open, setOpen, data, station }) => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();

  const loadingAssign = useSelector(
    (state) => state.search?.isLoadingComp?.[ADMIN_UNIT_LOADINGS.ASSIGN_EQUIPMENT]
  );

  const { values, setValues, errors, validate } = useForm(EMPTY_EQUIPMENT_VALUES, VALIDATIONS);
  const { equipment } = values;

  // Carga inicial: tipos + prefill del equipo ya asignado (incluido vía idCurrent)
  useEffect(() => {
    const init = async () => {
      dispatch(getElectronicEquipmentTypes());
      if (!data?.idEquipment) return;
      const list = await dispatch(
        getAvailableEquipment({
          stations: station?.id,
          idCurrent: data.idEquipment,
        })
      );
      const current = (list || []).find((eq) => eq.id === data.idEquipment);
      if (current) setValues(equipmentToValues(current));
    };
    init();
  }, []);

  const handleSubmit = () => {
    validate([], () => {
      const idEquipment = equipment?.id;
      if (!idEquipment) {
        setSnackbar("Selecciona un equipo para asignar", "warning");
        return;
      }
      dispatch(assignUnitEquipment(data.id, { idEquipment }, setOpen));
    });
  };

  return (
    <ModalV2
      open={open}
      onClose={setOpen}
      title={`Asignar equipo electrónico — Unidad ${data?.number || ""}`}
      submitBtnText="Guardar"
      onSubmit={handleSubmit}
      toRight
      isLoading={loadingAssign}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 15, width: "100%" }}>
        <TextField
          fullWidth
          label="Planta"
          value={station?.label || station?.name || ""}
          variant="outlined"
          disabled
        />

        <TextField
          fullWidth
          label="Unidad"
          value={data?.number || ""}
          variant="outlined"
          disabled
        />

        <EquipmentSelector
          values={values}
          onChange={setValues}
          station={station}
          idCurrent={data?.idEquipment}
          errors={errors}
        />
      </div>
    </ModalV2>
  );
};
